<button nz-button [disabled]="this.isLoading$ | async" nzType="primary" [nzSize]="size">
  <span nz-icon nzType="save" nzTheme="outline"></span>
  Save
</button>
